import React from 'react';
import ReactDOM from 'react-dom/client';
import './app.css';
import App from './App';

class ErrorBoundary extends React.Component<{children: React.ReactNode}, {error: Error | null}> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  render() {
    if (this.state.error) {
      return React.createElement('div', { style: { padding: 40, color: 'red', fontFamily: 'monospace' } },
        React.createElement('h1', null, 'App Error'),
        React.createElement('pre', null, this.state.error.message),
        React.createElement('pre', { style: { fontSize: 12 } }, this.state.error.stack)
      );
    }
    return this.props.children;
  }
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find root element');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);